<div class="top-menu">    

    <span fxShow="false" fxShow.gt-sm>
        
        <a style="color:black;" mat-button href="https://cafeunido.com">Ir a nuestra página <span *ngIf="settings.rtl">&rlm;</span></a>
    
    </span>  

</div>  